/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/
class CustomVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.productJson = this.querySelector("script[type='application/json']").innerText;
    this.productData = JSON.parse(this.productJson);
    this.inputs = this.querySelectorAll("input");
    this.variantData = this.productData.variants;
    this.currentVariant = this.productData.variants.find((variant) => variant.available);
    this.addToCart = this.closest(".hp-upsell-wrap").querySelector(".btn-bundle-upsell__add-to-cart");
    this.priceWrapper = this.closest(".hp-upsell-wrap").querySelector('.hp-upsell-price-row');
    console.log("Current Variant", this.currentVariant);
  }

  connectedCallback() {
    this.inputs.forEach((input) => input.addEventListener("change", this.handleVariantChange.bind(this), true))
    this.updateAddToCart(this.currentVariant);
  }

  handleVariantChange({ currentTarget }) {
    console.log("Variant Changed!");
    const value = currentTarget.value;
    const legend = currentTarget.closest("fieldset").querySelector(".radio__legend__current");
    legend.innerText = value;

    const selectedOptions = [];
    this.productData.options.forEach((option) => {
      selectedOptions.push(this.querySelector(`input[name='custom_options[${option}]']:checked`).value);
    });
    // console.log("selectedOptions", selectedOptions);
    const newVariant = this.variantData.find((variant) => variant.options.equals(selectedOptions));
    this.currentVariant = newVariant;
    this.updatePrice(newVariant);
    this.updateAddToCart(newVariant);
  }

  updateAddToCart(variant) {
    if (!this.addToCart) {
      return;
    }
    // console.log("Updating add to cart!", variant);
    if (variant.available) {
      this.addToCart.removeAttribute("disabled");
      this.addToCart.textContent = theme.strings.addToCart;
    } else {
      this.addToCart.setAttribute("disabled", true);
      this.addToCart.textContent = theme.strings.soldOut;
    }
  }

  updatePrice(variant) {
    console.log(variant);
    const variantPrice = variant.price;
    const variantCompareAtPrice = variant.compare_at_price || "";

    const priceElement = this.priceWrapper.querySelector('.hp-upsell-price')
    const compareAtPriceElement = this.priceWrapper.querySelector('.hp-upsell-price-old');
    if (priceElement) {
      priceElement.textContent = themeVendor.themeCurrency.formatMoney(variantPrice, theme.moneyCurrencyFormat);
    }
    if (compareAtPriceElement) {
      compareAtPriceElement.textContent = variantCompareAtPrice ? themeVendor.themeCurrency.formatMoney(variantCompareAtPrice, theme.moneyCurrencyFormat) : "";
    }
  }
}
if (!customElements.get('custom-variant-select')) {
  customElements.define('custom-variant-select', CustomVariantSelect);
}

class UpsellItem extends HTMLElement {
  constructor() {
    super();

    this.addToCart = this.querySelector(".btn-bundle-upsell__add-to-cart");
  }

  connectedCallback() {
    this.addToCart.addEventListener("click", this.handleAddToCart.bind(this), true);
  }

  handleAddToCart() {
    this.variant = this.querySelector('custom-variant-select').currentVariant;
    const mainProductVariantId = this.closest(".product-page").querySelector("input[name='id']").value;
    const mainProductVariantQty = this.closest(".product-page").querySelector("input[name='quantity']").value;
    console.log({ mainProductVariantId, mainProductVariantQty });
    const items = [];

    items.push({ id: this.variant.id, quantity: 1 });

    items.push({ id: mainProductVariantId, quantity: mainProductVariantQty });

    let formData = { 'items': items };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(res => res.json())
      .then(async (response) => {
        console.log(response);
        if (response.items.length) {
          document.querySelector("[data-product-add-popdown-wrapper]").dispatchEvent(new CustomEvent('theme:cart:popdown', {
            detail: {
              variant: response.items[0]
            },
            bubbles: true
          }));

          const cartJson = await fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json());
          console.log(cartJson);
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: {
              cart: cartJson
            },
            bubbles: true
          }));

          document.dispatchEvent(new CustomEvent('theme:cart:reload', {
            bubbles: true
          }));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

if (!customElements.get('upsell-item')) {
  customElements.define('upsell-item', UpsellItem);
}

(function () {

  document.querySelectorAll(".group_variant_link").forEach(swatch => {
      swatch.addEventListener("mouseover", handleMouseIn);
      swatch.addEventListener("mouseout", handleMouseOut);
  });
  
  function handleMouseIn(event) {
      const target = event.currentTarget;
      const productTitle = target.getAttribute("data-title");
      if (productTitle) {
          const legendValue = target.closest("fieldset").querySelector(".radio__legend--value");
          if (legendValue) legendValue.textContent = productTitle;
      }
  }
  
  function handleMouseOut(event) {
      const target = event.currentTarget;
      const activeTitle = target.closest("fieldset").querySelector(".group_variant_link.active").getAttribute("data-title");
      if (activeTitle) {
          const legendValue = target.closest("fieldset").querySelector(".radio__legend--value");
          if (legendValue) legendValue.textContent = activeTitle;
      }
  }


  // Radio Buttons Variant Picker First Selection
  const buttonRadios = document.querySelectorAll('.radio__button');
  if(buttonRadios.length > 0){
    const FirstButton = buttonRadios[0];
    const InnerInputTag = FirstButton.querySelector('input');
    InnerInputTag.removeAttribute('checked');
    InnerInputTag.click();
  }

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function (event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function (event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  function handleQuantity(event){
    const quantity = event.currentTarget.value;
    const currentOptionPrice = this.event.currentTarget.getAttribute('option-price');
    console.log(quantity);
    const closestForm = event.currentTarget.closest('.product-page');
    const closestBuyButton = event.currentTarget.closest('.product-page').querySelector('[data-button-price]');
    if(closestForm){
      closestForm.querySelector("[name='quantity']").value = quantity;      
    }
    if(closestBuyButton){
      closestBuyButton.innerText = currentOptionPrice + " " + Shopify.currency.active;      
    }
  }

  const customQuantityRadios = Array.from(document.querySelectorAll(".custom-quantity"));
  customQuantityRadios.forEach((customQuantityRadio)=> customQuantityRadio.addEventListener("click", handleQuantity.bind(this), true));
})();

//Change Collection Button according to active tab
const AllTabs = document.querySelectorAll('.tab-link');
const AllButtons = document.querySelectorAll('.tab-collection-button');
AllTabs.forEach(tab=>{
  tab.addEventListener('click',()=>{    
    const tab_index = tab.getAttribute('data-tab');
    AllButtons.forEach(button=>{
      const button_index = button.getAttribute('data-button');
      if(tab_index == button_index){
        console.log(tab_index + " == " + button_index);
        button.style.display = "block";
      } else{
        button.style.display = "none";
      }
    })
  })
})